import React, { useState, useEffect } from "react";
import "./PaymentException.css";
import PaymentDrawer from "./PaymentDrawer";

const dummyData = [
  {
    id: "1",
    orgName: "Seltous",
    pgName: "muffin-pay",
    referenceId: "RRN12345",
    utr: "UTR98765",
    amount: 1200,
    status: "SUCCESS",
    refundStatus: "PENDING",
    accountNo: "8504000025498",
    ifsc: "SBIN0001234",
    vpa: "user@upi",
    refunds: [
      { attemptNo: 1, status: "FAILED", amount: 1200 },
      { attemptNo: 2, status: "PENDING", amount: 1200 },
    ],
  },
  {
    id: "2",
    orgName: "Kwic",
    pgName: "razorpay",
    referenceId: "RRN67890",
    utr: "UTR12345",
    amount: 500,
    status: "FAILED",
    refundStatus: "SUCCESS",
    accountNo: "1234567890",
    ifsc: "HDFC000123",
    vpa: "test@upi",
    refunds: [{ attemptNo: 1, status: "SUCCESS", amount: 500 }],
  },
];

export default function PaymentExceptionDashboard() {
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setSelected(null);
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, []);

  return (
    <div className="pe-root">
      <h2 className="pe-title">⚠ Payment Exceptions</h2>

      <div className="pe-table-wrapper">
        <table className="pe-table">
          <thead>
            <tr>
              <th>Org</th>
              <th>PG</th>
              <th>Reference</th>
              <th>UTR</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Refund</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {dummyData.map((row) => (
              <tr key={row.id}>
                <td>{row.orgName}</td>
                <td>{row.pgName}</td>
                <td>{row.referenceId}</td>
                <td>{row.utr}</td>
                <td>₹{row.amount}</td>

                <td>
                  <span
                    className={`pe-status ${row.status.toLowerCase()}`}
                  >
                    {row.status}
                  </span>
                </td>

                <td>
                  <span
                    className={`pe-refund ${row.refundStatus.toLowerCase()}`}
                  >
                    {row.refundStatus}
                  </span>
                </td>

                <td>
                  <button
                    className="pe-view-btn"
                    onClick={() => setSelected(row)}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {selected && (
        <PaymentDrawer
          data={selected}
          onClose={() => setSelected(null)}
        />
      )}
    </div>
  );
}